/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import request from '@/utils/http';

// 首页列表数据
export const receiptList = (params) => {
    return request({
        url: `/api-tms/receipt/list`,
        method: 'get',
        params
    });
};

// 根据条件查询总数量
export const getTotalCounts = (params) => {
    return request({
        url: `/api-tms/receipt/searchReceiptCount`,
        method: 'get',
        params
    });
};

// 逾期列表查询
export const receiptSearchoverdue = (params) => {
    return request({
        url: `/api-tms/receipt/searchoverdue/${params}`,
        method: 'get'
    });
};

// 首页列表数据
export const receiptDetail = (params) => {
    return request({
        url: `/api-tms/receipt/detail/${params}`,
        method: 'get'
    });
};

// 回单印鉴查询
export const queryByTaskNo = (params) => {
    return request({
        url: `/api-tms/receipt/registration/queryByTaskNo`,
        method: 'get',
        params
    });
};

// 回单印鉴查询 新T
export const queryByTaskNoNewT = (params) => {
    return request({
        url: `api-antms/query/lsp/registration/queryByTaskNo?taskNo=${params}`,
        method: 'get'
    });
};

// 首页逾期接口
export const receiptOverdue = (data) => {
    return request({
        url: `/api-tms/receipt/overdue`,
        method: 'post',
        data
    });
};

// 首页签收接口 、 批量确认接口
export const receiptSign = (data) => {
    return request({
        url: `/api-tms/receipt/sign`,
        method: 'post',
        data
    });
};

// 首页拒收接口
export const receiptRejectsign = (data) => {
    return request({
        url: `/api-tms/receipt/rejectsign`,
        method: 'post',
        data
    });
};

// 上传图片
export const receiptUpload = (data) => {
    return request({
        url: `/api-tms/receipt/upload`,
        method: 'post',
        data
    });
};

// 删除图片
export const receiptDeleteReceiptpicture = (data) => {
    return request({
        url: `/api-tms/receipt/delete/receiptpicture`,
        method: 'delete',
        data
    });
};
// // 查询用户权限
// export const userdataAuth = (user, params = {}) => {
//     return request({
//         url: `/api-auth/user/${user}/dataAuth/D20190621009`,
//         method: 'get',
//         params
//     });
// };
// 仓库数据权限接口
export const userdataAuth = (user) => {
    return request({
        url: `/api-auth/getUserAllDataAuths?tenantCode=annto&userCode=${user}`,
        method: 'get'
    });
};
// 网点配送详情
export const deliveryDetailsList = (data) => {
    return request({
        url: `/api-tms/lastmile/receipt/detail/searchbyorder`,
        method: 'post',
        data
    });
};
// 网点配送详情附件查看
export const deliveryFiles = (data) => {
    return request({
        url: `/api-tms/lastmile/receipt/file/searchbyorder`,
        method: 'post',
        data
    });
};
// 网点配送详情确认
export const deliveryConfirm = (data) => {
    return request({
        url: `/api-tms/lastmile/receipt/net/confirm`,
        method: 'post',
        data
    });
};
// 网点配送详情驳回
export const deliveryReject = (data) => {
    return request({
        url: `/api-tms/lastmile/receipt/net/reject`,
        method: 'post',
        data
    });
};
export const getDictList = (params) => {
    return request({
        url: `/api-mdm/dictionaryDetail/dict`,
        method: 'get',
        params
    });
};
export const abnormalApprove = (data) => {
    return request({
        url: `/api-tms/receipt/electronicSignExceptionflowStart`,
        method: 'post',
        data
    });
};
export const getIflowStatus = (data) => {
    return request({
        url: `/api-tms/mipIflowInfo/getStatus`,
        method: 'post',
        data
    });
};
export const queryReceiptFileByHonghe = (data) => {
    return request({
        url: `/api-tms//receipt/queryReceiptFileByHonghe`,
        method: 'post',
        data
    });
};
export const insertReceiptFileByHonghe = (data) => {
    return request({
        url: `/api-tms//receipt/insertReceiptFileByHonghe`,
        method: 'post',
        data
    });
};

// 新T签收中心查看详情接口
export const getReceiptSignDetailInfo = data => {
    return request({
        url: `/api-antms/receipt/receipt/queryReceiptByTaskNo`,
        method: 'get',
        params: data
    });
};
